new Swiper("#image-carousel", {
  slidesPerView: "auto",
  spaceBetween: 12,
  freeMode: true,
  loop: true,
  grabCursor: true,
  autoplay:   // [Optional] for autoplay
    {
      delay: 0,
    },
    speed: 5000,  // [Optional] for autoplay
});
